var exports = {
  "RR": "x1cb7f6e3--d9b6fa--listing",
  "hs": "x1cb7f6e3--d9b6fa--listing-wrapper",
  "Qs": "x1cb7f6e3--d9b6fa--content",
  "iV": "x1cb7f6e3--d9b6fa--return-button",
  "lX": "x1cb7f6e3--d9b6fa--stuck",
};

module.exports = exports;
